/**
 *
 * RoleMembers
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Card, ListGroup } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import RoleDisplay from 'components/user/RoleDisplay.js';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import SelectUsers from 'components/interaction/SelectUsers/index.jsx';
import ClickableUser from 'components/user/ClickableUser.jsx';
import { getIdNumber } from 'utils/userIdRole.js';
import { idValues } from 'utils/arrays.js';
import sameRole from 'utils/sameRole.js';
import messages from './messages.js';

const MANAGER_TYPE = 3;

function RoleMembers(props) {
  const { schoolRole, addMembers, deleteMember } = props;
  const [show, setShow] = useState(false);
  const role = useCurrentRole();
  const intl = useIntl();
  const memberList = idValues(schoolRole.members);

  function handleAdd(users) {
    addMembers(users
      .filter((u) => memberList.every((o) => !sameRole(u, o)))
      .map((u) => ({ id: u.id, type: u.roleType })));
    setShow(false);
  }

  const fetchOptions = {
    url: 'sa/users',
    version: 2,
    typeField: 'type',
  };

  function noRemoveReason(member) {
    if (schoolRole.systemType !== MANAGER_TYPE) {
      return null; // No restrictions
    }
    if (sameRole(member, role)) {
      return intl.formatMessage(messages.cannotRemoveSelf);
    }
    if (memberList.length <= 1) {
      return intl.formatMessage(messages.atLeastOneMember);
    }
    return null;
  }

  return (
    <Card.Body className="">
      {memberList.length === 0 ? (
        <Alert variant="info"><FormattedMessage {...messages.noMembers} /></Alert>
      ) : (
        <ListGroup className="mb-4">
          {memberList.map((member) => {
            const { id, avatar, roleType } = member;
            const title = noRemoveReason(member);

            return (
              <ListGroup.Item key={id} className="px-0">
                <div className="d-flex align-items-center justify-content-between">
                  <AvatarWithText src={avatar} className="flex-grow-1">
                    <ClickableUser user={member} />
                  </AvatarWithText>
                  <RoleDisplay type={roleType} capitalized />
                  <span title={title}>
                    <DeleteButton confirmText={{ ...messages.confirmRemoveMember, values: member }} onClick={() => deleteMember(member)} className="py-0" icon="lower-1 ss-delete" disabled={Boolean(title)} />
                  </span>
                </div>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      )}
      <Button variant="light" onClick={() => setShow(true)} className="mb-3">
        <FormattedMessage {...messages.adduser} />
      </Button>
      <SelectUsers
        show={show}
        value={memberList}
        exclusions={memberList.map(getIdNumber)}
        onChange={handleAdd}
        onHide={() => setShow(false)}
        fetchOptions={fetchOptions}
      />
    </Card.Body>
  );
}

RoleMembers.propTypes = {
  addMembers: PropTypes.func,
  deleteMember: PropTypes.func,
  schoolRole: PropTypes.object,
};

export default RoleMembers;
